import api from "../../../../lib/api";
import { ICustomerCreate, ICustomerListSearch, IEditCustomerPayload } from "../../../../types/master/customerInterface";

export const createCustomerApi = async (data: ICustomerCreate) => {
  return await api.post(`/customer`, data);
};

export const getCustomerListApi = async ({ page, pageLimit, ...filters }: ICustomerListSearch) => {
  const params = new URLSearchParams({ search: filters.search ?? "" });
  // only filters that are set go on the URL
  Object.entries(filters).forEach(([key, value]) => {
    if (key !== "search" && value !== undefined && value !== "") params.append(key, String(value));
  });
  return await api.get(`/customer/${page}/${pageLimit}?${params.toString()}`)
}

// status only, for bulk Active / Inactive; editCustomerDataByIdApi would send an empty customer_code
export const updateCustomerStatusApi = (id: number, profile_status: "ACTIVE" | "INACTIVE") => {
  return api.put(`/customer/${id}`, { profile_status })
}

export const getCustomerDataByIdApi = async (id: number) => {
  return await api.get(`/customer/${id}`)
}
 
export const editCustomerDataByIdApi = async (payload: IEditCustomerPayload) => {
  const normalizedPayload = {
    ...payload.data,
    customer_code: String(payload.data?.customer_code ?? ""),
  };
  return await api.put(`/customer/${payload.id}`, normalizedPayload);
};
  
export const uploadCustomerDocsApi = async (data: FormData) => {
  return await api.post(`/customer-documents`, data)
}

export const getCustomerDocLinkApi = (id : number) => {
  return api.get(`/customer-documents/signed-url?id=${id}`);
};

export const deleteDocApi = (id : number) => {
  return api.delete(`customer-documents/${id}`);
}